module.exports = __webpack_public_path__ + "img/ring_y_skip_1_null@2x.bc1d869c.png";